import idb from '@/store/services/idb';
import { WsCalls } from '@/store/services/wsCalls';

// initial state
const state = () => ({
	folhetos: [],
	lembretes: [],
  premios: [],
  views: [],
  points: 0,
  points_products: [],
  points_history: [],
  points_expired: 0,
  points_history_expired: [],
  loadingFolhetos: true,
  loadingLembretes: true,
  loadingPremios: true,
  loadingPoints: true,
  loadingHistory: true
})

// getters
const getters = {
	getFolhetos: (state) => {
		return state.folhetos;
	},
	getLembretes: (state) => {
		return state.lembretes;
	},
	getPremios: (state) => {
		return state.premios;
	},
	getPoints: (state) => {
		return state.points;
	},
	getPointsProducts: (state) => {
		return state.points_products;
	},
	getPointsExpired: (state) => {
		return state.points_expired;
	},
	getPointsHistory: (state) => {
		return state.points_history;
	},
	getPointsHistoryExpired: (state) => {
		return state.points_history_expired;
	},
  checkView: (state) => (type, id) => {
    var view = state.views.find(v => v.type == type && v.id == id);
		return view != undefined ? false : true;
  }
}

// actions
const actions = {
	async loadFolhetos({ state, commit, rootGetters, rootState }) {
    commit('setLoadingFolhetos', true);
    if(state.views.length == 0 && await idb.getData('views')){
      commit('loadViews', { "views": await idb.getData('views'), "isu": rootState.user.isu });
    }
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'userFlyers', rootGetters['main/getConfig']).then(function (response) {
        if (response.data.cod == 100 && response.data.return.flyers != null) {
          commit('setFolhetos', response.data.return.flyers);
          commit('setLoadingFolhetos', false);
          resolve(true);
        } else {
          commit('setLoadingFolhetos', false);
          resolve(false);
        }
      });
    })
	},
	async loadLembretes({ state, commit, rootGetters, rootState }) {
    commit('setLoadingLembretes', true);
    if(state.views.length == 0 && await idb.getData('views')){
      commit('loadViews', { "views": await idb.getData('views'), "isu": rootState.user.isu });
    }
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'userReminder', rootGetters['main/getConfig']).then(function (response) {
        if (response.data.cod == 100 && response.data.return.reminders != null) {
          commit('setLembretes', response.data.return.reminders);
          commit('setLoadingLembretes', false);
          resolve(true);
        } else {
          commit('setLoadingLembretes', false);
          resolve(false);
        }
      });
    });
	},
	async loadProducts({ commit, rootGetters }, paginacao) {
    commit('setLoadingHistory', true);
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'crmpointsProduct', rootGetters['main/getConfig'], paginacao).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null && response.data.return.length > 0) {
          if(paginacao == 0){
            commit('setProducts', response.data.return);
          } else {
            commit('concatProducts', response.data.return);
          }
          commit('setLoadingHistory', false);
          resolve(true);
        } else {
          commit('setLoadingHistory', false);
          resolve(false);
        }
      });
    });
	},
	async loadProductsDetail({ rootGetters }, sku) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'crmpointsProduct', rootGetters['main/getConfig'], "detail/"+sku).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          resolve(response.data.return);
        } else {
          resolve(false);
        }
      });
    });
	},
	async loadPoints({ commit, rootGetters }) {
    commit('setLoadingPoints', true);
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'crmpointsResume', rootGetters['main/getConfig']).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          commit('setPoints', response.data.return.points);
          commit('setLoadingPoints', false);
          resolve(true);
        } else {
          commit('setPoints', 0);
          commit('setLoadingPoints', false);
          resolve(false);
        }
      });
    });
	},
	async loadPointsHistory({ commit, rootGetters }, paginacao) {
    commit('setLoadingHistory', true);
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'crmpointsHistory', rootGetters['main/getConfig'], paginacao).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          if(paginacao == 0){
            commit('setPointsHistory', response.data.return.points_history);
          } else {
            commit('concatPointsHistory', response.data.return.points_history);
          }
          commit('setLoadingHistory', false);
          resolve(true);
        } else {
          commit('setLoadingHistory', false);
          resolve(false);
        }
      });
    });
	},
	async loadPointsExpired({ commit, rootGetters }) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'crmpointsHistoryExpire', rootGetters['main/getConfig']).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          commit('setPointsExpired', response.data.return.total_points_history_expiring);
          resolve(true);
        } else {
          commit('setPointsExpired', 0);
          resolve(false);
        }
      });
    });
	},
	async loadPointsHistoryExpired({ commit, rootGetters }, paginacao) {
    commit('setLoadingHistory', true);
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'crmpointsHistoryExpire', rootGetters['main/getConfig'], paginacao).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          if(paginacao == 0){
            commit('setPointsHistoryExpired', response.data.return.points_history_expiring);
          } else {
            commit('concatPointsHistoryExpired', response.data.return.points_history_expiring);
          }
          commit('setLoadingHistory', false);
          resolve(true);
        } else {
          commit('setLoadingHistory', false);
          resolve(false);
        }
      });
    });
	},
	async loadLembretesDetail({ commit, rootGetters, dispatch }, id) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'userReminderBy', rootGetters['main/getConfig'], id).then(function (response) {
        if (response.data.cod == 100) {
          commit('updateLembretes', { "id": id, "retorno": response.data.return.reminder });
          dispatch('getImage', response.data.return.reminder.hash);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
	},
  async getImage ({ commit, rootGetters }, hash) {
    return new Promise((resolve) => {
      if(hash != ""){
        WsCalls.callMethodWS('IMAGE', 'servicesImage', rootGetters['main/getConfig'], hash).then(function (response) {
          if (response.data.cod == 404) {
            commit('setImage', { "hash": hash, "image": 'no-image' });
            resolve(true);
          } else {
            commit('setImage', { "hash": hash, "image": URL.createObjectURL(response.data) });
            resolve(true);
          }
        }).catch(() => {
          commit('setImage', { "hash": hash, "image": 'no-image' });
        });
      } else {
        commit('setImage', { "hash": hash, "image": 'no-image' });
        resolve(true);
      }
    })
  },
	async getPdf({ commit, rootGetters }, hash) {
    return new Promise((resolve) => {
      if(hash != ""){
        WsCalls.callMethodWS('IMAGE', 'servicesPdf', rootGetters['main/getConfig'], hash).then(function (response) {
          if (response.data.cod == 404) {
            commit('setPdf', { "hash": hash, "pdf": 'no-image' });
            resolve(true);
          } else {
            commit('setPdf', { "hash": hash, "pdf": URL.createObjectURL(response.data) });
            resolve(true);
          }
        }).catch(() => {
          commit('setPdf', { "hash": hash, "pdf": null });
        });
      } else {
        commit('setPdf', { "hash": hash, "pdf": null });
        resolve(true);
      }
    });
	},
	async registerView({ commit, rootGetters, rootState }, { type, id}) {
    return new Promise(async (resolve) => {
      if(type == 'lembrete'){
        WsCalls.callMethodWS('POST', 'viewReminder', rootGetters['main/getConfig'], { 'id_reminder': id });
      }
      commit('setView', { "type": type , "id": id });
      await idb.loadData('views', { "type": type , "id": id, "isu": rootState.user.isu });
      resolve(true);
    });
	},
	async shake({ commit, rootGetters }) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'shake', rootGetters['main/getConfig']).then(function (response) {
        if (response.data.cod == 100) {
          if(response.data.return.winner == 1){
            commit('addPremios', response.data.return.voucher);
          }
          resolve(response.data.return);
        } else {
          resolve(false);
        }
      });
    });
	},
	async loadPremios({ commit, rootGetters }) {
    commit('setLoadingPremios', true);
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'vouchers', rootGetters['main/getConfig']).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null && response.data.return.length > 0) {
          commit('setPremios', response.data.return);
          commit('setLoadingPremios', false);
          resolve(true);
        } else {
          commit('setLoadingPremios', false);
          resolve(false);
        }
      });
    });
	},
	async loadPremiosDetail({ rootGetters }, id) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'voucher', rootGetters['main/getConfig'], "detail/"+id).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          resolve(response.data.return);
        } else {
          resolve(false);
        }
      });
    });
	},
}

// mutations
const mutations = {
	setFolhetos(state, folhetos){
		state.folhetos = folhetos;
	},
	setLembretes(state, lembretes){
		state.lembretes = lembretes;
	},
	setPremios(state, premios){
		state.premios = premios;
	},
	addPremios(state, premios){
    state.premios = state.premios.concat(premios);
	},
	setProducts(state, points_products){
		state.points_products = points_products;
	},
	concatProducts(state, points_products){
    state.points_products = state.points_products.concat(points_products);
	},
	setPoints(state, points){
		state.points = points;
	},
	setPointsHistory(state, points_history){
		state.points_history = points_history;
	},
	concatPointsHistory(state, points_history){
    state.points_history = state.points_history.concat(points_history);
	},
	setPointsExpired(state, points_expired){
		state.points_expired = points_expired;
	},
	setPointsHistoryExpired(state, points_history_expired){
		state.points_history_expired = points_history_expired;
	},
	concatPointsHistoryExpired(state, points_history_expired){
    state.points_history_expired = state.points_history_expired.concat(points_history_expired);
	},
	updateLembretes(state, { id, retorno}){
    var lembretes = state.lembretes.find(p => p.id == id);
    if(lembretes != undefined){
      lembretes.hash = retorno.hash;
      lembretes.description = retorno.description;
    }
	},
  setPdf (state, { hash, pdf }) {
    var folheto = state.folhetos.find(p => p.hash == hash);
    if(folheto != undefined){
      folheto.pdf = pdf;
    }
  },
  setImage (state, { hash, image }) {
    var lembrete = state.lembretes.find(p => p.hash == hash);
    if(lembrete != undefined){
      lembrete.image = image;
    }
  },
  setView (state, { type, id }) {
    var view = state.views.find(v => v.type == type && v.id == id);
    if(view == undefined){
      state.views.push({
        "type": type,
        "id": id
      });
    }
  },
	setLoadingFolhetos(state, status){
		state.loadingFolhetos = status;
	},
	setLoadingLembretes(state, status){
		state.loadingLembretes = status;
	},
	setLoadingPremios(state, status){
		state.loadingPremios = status;
	},
	setLoadingPoints(state, status){
		state.loadingPoints = status;
	},
	setLoadingHistory(state, status){
		state.loadingHistory = status;
	},
  loadViews: (state, { views, isu }) => {
    state.views.splice(0, state.views.length);
    if (views.length > 0) {
      views.forEach(function(element) {
        if(element.isu == isu){
            state.views.push({
              type: element.type,
              id: element.id
            });
        }
      });
    }
  },
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}